/** Strips a phone number down to digits, keeping a leading `+`. */
export function sanitisePhone(input: string): string {
    if (!input) return '';
    const trimmed = input.trim();
    const hasLeadingPlus = trimmed.startsWith('+');
    const digitsOnly = trimmed.replace(/\D/g, '');
    return hasLeadingPlus ? (digitsOnly ? `+${digitsOnly}` : '+') : digitsOnly;
}
